"use client";
import Link from "next/link";
import { Box, type BoxProps } from "@mui/material";

type BoxLinkProps = BoxProps<typeof Link>;

export default function BoxLink(props: BoxLinkProps) {
    return <Box component={Link} {...props} />;
}
